export const treatments = [
  {
    title: 'Highly-rated therapists',
    description:
      'We thoroughly vet and only invite top clinical experts to join Cerebral. 99% of our therapists have a <strong>4.9 approval rating or higher</strong> from their clients.'
  },
  {
    title: 'Cognitive behavioral therapy (CBT)',
    description:
      'CBT helps identify specific challenges in your thought patterns and develop skills to respond to them more effectively. One of the most common and effective forms of talk therapy.'
  },
  {
    title: 'Prescription medication from licensed prescribers',
    description:
      'Explore medication options with a licensed prescriber who will determine whether a prescription is appropriate. We do not prescribe stimulants like Adderall, Vyvanse, or Concerta at this time.'
  }
];

export const treatmentSubscription =
  'Medication is shipped directly to you — and can cost up to <strong>80% less</strong> than retail prices';
